import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const ContactRecommendedCandidateModalLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ContactRecommendedCandidateModal" */
      './ContactRecommendedCandidateModal'
    ),
  loading: LoadingModal,
});
